import { cn } from "@/lib/utils";

export function Gradient({
	className,
	...props
}: React.ComponentPropsWithoutRef<"div">) {
	return (
		<div
			{...props}
			className={cn(
				"bg-linear-115 from-28% from-primary via-70% via-secondary to-primary sm:bg-linear-145",
				className,
			)}
		/>
	);
}

export function Solid({
	className,
	...props
}: React.ComponentPropsWithoutRef<"div">) {
	return <div {...props} className={cn("bg-green-300/50", className)} />;
}

export function GradientBackground() {
	return (
		<div className="relative mx-auto max-w-7xl">
			<div
				className={cn(
					"-top-44 -right-60 absolute h-60 w-[36rem] transform-gpu md:right-0",
					"bg-linear-115 from-28% from-primary/40 via-70% via-secondary/40 to-primary/40",
					"rotate-[-10deg] rounded-full blur-3xl",
				)}
			/>
		</div>
	);
}
